module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-153.07eaa712.svg";